<script setup lang="ts">
import PartTitleHead from '@parts/part-title-head.vue';
import ButtonBlurred from '@buttons/button-blurred.vue';
import { computed } from 'vue';

const props = defineProps({
	fields: {
		type: Object,
		default: () => ({})
	}
});
const columns = computed(() => {
	const { list } = props.fields;

	if (!list) { return null; }

	const middleIndex = Math.ceil(list.length / 2);
	const leftColumn = list.slice(0, middleIndex);
	const rightColumn = list.slice(middleIndex);
	return [leftColumn, rightColumn];
});
</script>
<template>
	<section class="section-help">
		<div class="wrapper">
			<transition
				appear
				name="fade"
				style="--animation-delay: 0s"
			>
				<part-title-head
					v-if="fields.title || fields.subtitle"
					:icon="fields?.icon"
					:title="fields.title"
					:subtitle="fields.subtitle"
					class="section-help__content"
				></part-title-head>
			</transition>

			<div
				v-if="columns"
				class="section-help__list"
			>
				<!--
					Для <transition> нужно задать продолжительность анимации: animation-delay.
					Через "--animation-count" передаем количество элементов в списке, для построения продолжительсности.
				-->
				<transition
					v-for="(column, index) in columns" :key="index"
					appear
					name="show-up-container-items"
					:style="`--animation-delay: 0.2s;
					--animation-item-delay: 0.2s;
					--animation-duration: 0.6s;
					--animation-count: ${columns?.length || 0}`"
				>
					<div
						class="section-help__list-column"
					>
						<button-blurred
							v-for="(button, index) in column" :key="index"
							:icon="button.icon"
							:url="button.url || null"
							:to="button.to"
							:loading="!button.url && !button.to"
							gradient
							class="section-help__list-item"
						>
							<span v-html="$t(button.title)"></span>
						</button-blurred>
					</div>
				</transition>
			</div>
		</div>
	</section>
</template>
<style lang="scss">
.section-help {
	padding: 0 0 2.4rem;

	&__list {
		display: flex;
		gap: 0.5rem;
	}

	&__list-column {
		display: flex;
		flex-direction: column;
		gap: 0.8rem;
		flex: 1 1 0;
		min-width: 0;

		&:nth-child(odd) {
			.section-help {
				&__list-item {
					&:nth-child(odd) {
						min-height: 18.9rem;
						@include min-desktop {
							height: 22rem;
						}
					}
					&:nth-child(even) {
						min-height: 14.6rem;
						@include min-desktop {
							height: 16rem;
						}
					}
				}
			}
		}
		&:nth-child(even) {
			.section-help {
				&__list-item {
					&:nth-child(odd) {
						min-height: 14.6rem;
						@include min-desktop {
							height: 16rem;
						}
					}
					&:nth-child(even) {
						min-height: 18.9rem;
						@include min-desktop {
							height: 22rem;
						}
					}
				}
			}
		}


	}

	&__list-item {
		--button-icon-size: 5rem;
		--button-svg-size: 2.4rem;
		backdrop-filter: blur(33px);
		flex: 1 1 auto;

		@include min-desktop {
			padding: 2.4rem;
		}
	}
}
</style>


